export default "__VITE_ASSET__CvpEmxWS__"